import { useCallback, useState } from 'react';
import { useGetCallSessionInprogressQuery } from 'services';
import { FindAllCallSessionDto, FindAllChatSessionsHistoryDto, UseQueryOptionsType } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';

const pageSize = DEFAULT_PAGE_SIZE;

export function useOmniCallSessionInprogressList(
  params: Omit<FindAllCallSessionDto, 'skip' | 'limit'>,
  options?: UseQueryOptionsType
) {
  const { keyword, isHandleByAi, callSource } = params;

  const [skip, setSkip] = useState(0);

  const {
    data: dataResponse,
    isLoading,
    isFetching,
    refetch
  } = useGetCallSessionInprogressQuery(
    {
      skip,
      limit: pageSize,
      keyword,
      isHandleByAi,
      callSource
    },
    {
      ...options
    }
  );

  const { rows, count } = dataResponse?.data || {};

  const hasMore = Boolean(rows && count && rows.length < count);

  const handleLoadMore = useCallback(() => {
    if (hasMore && !isFetching) {
      setSkip(rows?.length ?? 0);
    }
  }, [hasMore, skip, isFetching]);

  const resetPage = () => {
    setSkip(0);
  };

  return {
    callSessionInprogress: rows || [],
    count: count || 0,
    isFetching,
    isLoading,
    handleLoadMore,
    hasMore,
    resetPage,
    refetch
  };
}
